import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/index'
        }, {
          path: '/index',
          name: 'index',
          component: resolve => require(['@/view/Index'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '首页'
          }

        }, {
          name: 'login',
          path: '/Login_login',
          component: resolve => require(['@/view/Login_login'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '登录'
          }
        }, {
          name: 'callback',
          path: '/Callback',
          component: resolve => require(['@/view/Callback'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '登录'
          }
        }, {
          name: 'sign',
          path: '/sign',
          component: resolve => require(['@/view/sign'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '参会类型'
          }
        }, {
          name: 'person',
          path: '/person',
          component: resolve => require(['@/view/person'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '个人中心'
          }
        }, {
          name: 'registration',
          path: '/registration',
          component: resolve => require(['@/view/registration'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '报名注册'
          }
        }, {
          path: '/application',
          name: 'application',
          component: resolve => require(['@/view/Software_Sign'], resolve),
          // component: resolve => require(['@/view/Application'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '报名注册'
          },
          // children: [
          //   {
          //     path: '/software',
          //     redirect: '/software/smartTown'
          //   },
          //
          //   {
          //     path: '/software/smartTown',
          //     name: 'software',
          //     component: resolve => require(['@/view/Software_smartTown'], resolve),
          //     meta: {
          //       title: '报名注册丨个人中心'
          //     }
          //   },
          //   {
          //     name: 'sign',
          //     path: '/software/sign',
          //     component: resolve => require(['@/view/Software_Sign'], resolve),
          //     meta: {
          //       title: '报名注册'
          //     }
          //   },
          //   {
          //     path: '/software/bigData',
          //     name: 'software',
          //     component: resolve => require(['@/view/Software_bigData'], resolve),
          //     meta: {
          //       title: '报名注册丨注册报名'
          //     }
          //   }
          // ]
        }, {
          path: '/overview',
          name: 'overview',
          component: resolve => require(['@/view/Overview'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '会议概况'
          }
        }, {
          path: '/trends',
          name: 'trends',
          component: resolve => require(['@/view/Trends'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '会议动态'
          }
        },
        {
          path: '/NewDetail',
          name: 'NewDetail',
          component: resolve => require(['@/view/NewDetail'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '动态详情'
          },
          hidden: false,
        }, {
          path: '/committee',
          name: 'committee',
          component: resolve => require(['@/view/Committee'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '组委会'
          }
        }, {
          path: '/schedule',
          name: 'schedule',
          component: resolve => require(['@/view/Schedule'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '日程安排'
          }
        }, {
          path: '/branch',
          name: 'branch',
          component: resolve => require(['@/view/Branch'], resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '分会场'
          }
        },
        {
          path: '/guide',
          name: 'guide',
          component: resolve => require(['@/view/Guide'],resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '参会指南'
          }
        },
        {
          path: '/exhibition',
          name: 'exhibition',
          component: resolve => require(['@/view/exhibition'],resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '参展指南'
          }
        },
        {
          path: '/information',
          name: 'information',
          component: resolve => require(['@/view/Information'],resolve),
          meta: {
            title: localStorage.getItem('meetingData') + '资料下载'
          }
        }
      ]
    }
  ]
});

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};




// WEBPACK FOOTER //
// ./src/router/index.js